import { Map } from 'eemovel-map-library';
import { useCallback, useEffect, useMemo, useState } from 'react';

type UsePoligonOnMapReturn = {
  checkForPolygonOnMap: () => void;
  isPoligonOnMap: boolean;
  isCircleOnMap: boolean;
};

export const usePoligonOnMap = (): UsePoligonOnMapReturn => {
  const [isPoligonOnMap, setIsPoligonOnMap] = useState(false);
  const [isCircleOnMap, setIsCircleOnMap] = useState(false);
  const checkForPolygonOnMap = useCallback(() => {
    const hasPoligon = Map.PoligonOnMap && Map.PoligonOnMap.getMap() !== null;
    const hasCircle =
      (Map.markerCircle && Map.markerCircle.getMap() !== null) || false;
    setIsPoligonOnMap(!!hasPoligon);
    setIsCircleOnMap(!!hasCircle);
  }, []);
  useEffect(() => {
    checkForPolygonOnMap();
  }, [Map.PoligonOnMap, Map.markerCircle]);
  useEffect(() => {
    window.addEventListener('mouseup', checkForPolygonOnMap);
    return () => {
      window.removeEventListener('mouseup', checkForPolygonOnMap);
    };
  }, []);
  return {
    checkForPolygonOnMap,
    isPoligonOnMap,
    isCircleOnMap,
  };
};
